import { arc, type Arc } from '../geom';
import type { ArcNode } from '../model';
import { evaluatePoint, pointFields, pointValues } from './parts';
import type { EntityDefinition } from './types';

export const ARC: EntityDefinition<ArcNode, Arc> = {
  type: 'arc',
  label: 'Arc',
  fields: [
    ...pointFields('center', 'Center'),
    { path: 'radius', label: 'Radius', unit: 'length' },
    { path: 'startAngle', label: 'Start angle', unit: 'angle' },
    { path: 'endAngle', label: 'End angle', unit: 'angle' },
  ],
  resolve: (node, evaluate) =>
    arc(
      evaluatePoint(node.center, evaluate),
      evaluate(node.radius),
      evaluate(node.startAngle),
      evaluate(node.endAngle),
    ),
  fromShape: (a) => ({
    ...pointValues('center', a.center),
    radius: a.radius,
    startAngle: a.start,
    endAngle: a.end,
  }),
};
